import React, { useEffect, useState } from 'react'
import { faCss3, faJsSquare, faReact } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ciscoLogo from '../../assets/images/Cisco.png' // Import the Cisco logo image
import ADLogo from '../../assets/images/ADLogo.png'
import AzureLogo from '../../assets/images/AzureLogo.png'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                'H',
                'i',
                ',',
                ' ',
                'I',
                "'",
                'm',
                ' ',
                'H',
                'a',
                'd',
                'i',
              ]}
              idx={15}
            />
          </h1>
          <p className="about-me-text">
            I am a graduate of Royal Holloway University of London, where I
            earned a degree in Computer Science. Currently, I am working as a
            Service Desk Analyst at Dreams, where I focus on maintaining system
            stability, delivering technical support, and ensuring compliance
            with IT security standards.
          </p>
          <p className="about-me-text">
            In parallel with my career, I developed this website using ReactJS
            as a side project. It serves as a platform to showcase my
            post-university achievements and demonstrate my growth in IT
            Networking, Infrastructure, Security and coding.
          </p>
          <p className="about-me-text">
            With a strong foundation in IT Networking/Infrastructure, Cyber
            Security and coding, I am passionate about leveraging my knowledge
            to solve complex technical challenges and drive improvements in team
            efficiency. I have hands-on experience with tools such as Active
            Directory, Azure, and Mimecast, which I use to ensure operational
            effectiveness and security across systems.
          </p>

          <p className="about-me-text">
            As I continue my career in IT, I remain committed to enhancing my
            skills and expanding my expertise, aiming to contribute innovative
            solutions in Infrastructure and Cyber Security.
          </p>
          <a href="mailto:hadidabbur@icloud.com" className="contact-button">
            CONTACT ME
          </a>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <img
                src={ciscoLogo}
                alt="Cisco Logo"
                style={{ width: '80px', height: '80px' }}
              />
            </div>
            <div className="face2">
              <img
                src={ADLogo}
                alt="AD Logo"
                style={{ width: '80px', height: '80px' }}
              />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <img
                src={AzureLogo}
                alt="Azure Logo"
                style={{ width: '80px', height: '80px' }}
              />
            </div>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default About
